<template>
  <div class="loader-cont">
    <div class="loader-cont__wrapper">
      <div class="loader"></div>
      <div class="loader_text">{{ getTranslations.home_resuming_game_text }}</div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import webSocket from '@/common/webSocket';
import auth from '@/common/auth';
import { ParseResponseMixin, GameMixin, GameMixin2 } from '@/common/mixins/game';

export default {
  name: 'resuming-game',
  mixins: [ParseResponseMixin, GameMixin, GameMixin2],
  watch: {
    stompClient: {
      handler() {
        console.log('change to stompclient!');
        // eslint-disable-next-line
        console.log('connected: ' + this.stompClient.connected);
        if (this.stompClient.connected) this.hasConnectAtLeastOneTime = true;
        else if (this.hasConnectAtLeastOneTime) this.stompFailure('lock screen error');
      },
      deep: true,
    },
  },
  data() {
    return {
      hasConnectAtLeastOneTime: false,
      stompClient: null,
      subscription1: null,
      subscription2: null,
      subscription3: null,
      subscription4: null,
      goToRoundEndedScreen: false,
      resumingTimer: null,
      isResume: true,
    };
  },
  created() {
    console.log('=====> in ResumingGame created hook');
    this.stompClient = webSocket.getGameStompClient();
    // if we have refreshed the page/cleaned the cache the stompClient/websocket is null
    // so we need to create a new one
    if (this.stompClient === null || !this.stompClient.connected) {
      this.stompClient = webSocket.createNewStompClient('/gameData');
      this.stompClient.connect({ Authorization: auth.getJwt() }, () => {
        this.subscribeToGameTopics();
      });
    } else {
      console.log('this.stompClient:', this.stompClient);
      this.subscribeToGameTopics();
    }
  },
  beforeDestroy() {
    // if for any reason we leave this component earlier from the websocket's response,
    // unsubscribe from the subscribed channels
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    clearTimeout(this.resumingTimer);
  },
  methods: {
    ...mapMutations('game', [
      'setGameResuming',
      'setPlayersCurrentRoundScores',
      'setCurrentRoundNumber',
      'setPlayersCurrentThemes',
      'setPlayersCurrentSelectedTheme',
      'setPlayersHelpsUsedStatus',
      'setGameDTOForResumeGameOnly',
    ]),
    stompFailure(error) {
      console.log(error);
      window.location.reload();
    },
    subscribeToGameTopics() {
      this.getSelectedTheme();
      this.getCTAs();
      this.getNextCTA();
      this.getThemesForNextRound();
      this.ifNoDataFetchedThroughChannelAfterConfigurableTimePeriod();
    },
    updatePlayersScoreFromGameDTO(gameDTO) {
      this.setPlayersCurrentRoundScores({
        homePlayerRoundScore: gameDTO.homeUserDetails.score,
        awayPlayerRoundScore: gameDTO.awayUserDetails.score,
      });
    },
    updateResumingStatusAndGoToPage(page) {
      clearTimeout(this.resumingTimer);
      this.setGameDTOForResumeGameOnly(null);
      this.setGameResuming(false);
      this.$router.replace(page);
    },
    ifNoDataFetchedThroughChannelAfterConfigurableTimePeriod() {
      if (this.gameStateEnumForResumeGame === 'GAME_FINISHED' || this.gameStateEnumForResumeGame === 'SHOW_GAME_ROUND_END') {
        console.log(`GameStateEnum:  ${this.gameStateEnumForResumeGame}`);
        this.resumingTimer = setTimeout(() => {
          console.log('Going To Home..');
          this.normalTransition = true;
          this.updateResumingStatusAndGoToPage('/home');
        }, (this.timeWinnerIndication + 6000));
      }
    },
    getSelectedTheme() {
      // console.clear();
      console.log(`Subscribing to channel: /topic/categorySelected/${this.gameID}`);
      this.subscription1 = this.stompClient.subscribe(`/topic/categorySelected/${this.gameID}`, (response) => {
        this.subscription1.unsubscribe();
        console.log('[ResumingGame] Inside categorySelected response');
        // parse server response and return if any errors occur
        const responseBody = this.parseServerResponse(response.body);
        if (responseBody === null) {
          return;
        }
        const responseData = responseBody.data;
        const gameDTO = responseData.gameDTO;
        console.log('responseData:', responseData);
        if (gameDTO.gameStateEnum === 'CATEGORY_SELECTED') {
          console.log('gameStateEnum: CATEGORY_SELECTED');
          this.setCurrentRoundNumber(gameDTO.homeUserDetails.roundDTOList.length + 1);
          this.updatePlayersScoreFromGameDTO(gameDTO);
          // get the selected theme (as object) from the array of objects and save them in a payload object
          this.setPlayersCurrentSelectedTheme({
            homePlayerCurrentSelectedTheme: gameDTO.homeUserDetails.themeDTOList.filter(obj => obj.id === responseData.themeId)[0],
            awayPlayerCurrentSelectedTheme: gameDTO.awayUserDetails.themeDTOList.filter(obj => obj.id === responseData.themeId)[0],
          });
          this.normalTransition = true;
          console.log('going to selectedTheme page...');
          this.updateResumingStatusAndGoToPage('/selectedTheme');
        }
      });
    },
    getCTAs() {
      console.log(`Subscribing to channel: /topic/ctasFetched/${this.gameID}`);
      this.subscription2 = this.stompClient.subscribe(`/topic/ctasFetched/${this.gameID}`, (response) => {
        this.subscription2.unsubscribe();
        console.log('[ResumingGame] Inside ctasFetched response');
        // parse server response and return if any errors occur
        const responseData = this.parseServerResponse(response.body);
        if (responseData === null) {
          return;
        }
        const gameDTO = responseData.gameDTO;
        console.log('responseData', responseData);
        if (gameDTO.gameStateEnum === 'CTA_TO_BE_ANSWERED') {
          this.setCurrentRoundNumber(gameDTO.homeUserDetails.roundDTOList.length);
          this.updatePlayersScoreFromGameDTO(gameDTO);
          this.setPlayersCurrentSelectedTheme({
            homePlayerCurrentSelectedTheme: responseData.themeDTO,
            awayPlayerCurrentSelectedTheme: responseData.themeDTO,
          });
          this.saveQuestionDataForNextQuestion(responseData);
          this.setPlayersHelpsUsedStatus({
            homePlayerCheatHelpUsed: gameDTO.homeUserDetails.cheatUsed,
            homePlayerFiftyFiftyHelpUsed: gameDTO.homeUserDetails.fiftyFiftyUsed,
            awayPlayerCheatHelpUsed: gameDTO.awayUserDetails.cheatUsed,
            awayPlayerFiftyFiftyHelpUsed: gameDTO.awayUserDetails.fiftyFiftyUsed,
          });
          this.normalTransition = true;
          console.log('going to game page...');
          this.updateResumingStatusAndGoToPage('/game');
        }
      });
    },
    getNextCTA() {
      console.info(`Subscribing to channel: /topic/ctaSelected/${this.gameID}`);
      this.subscription3 = this.stompClient.subscribe(`/topic/ctaSelected/${this.gameID}`, (response) => {
        console.log('[ResumingGame] Inside ctaSelected response');
        // parse server response and return if any errors occur
        const responseBody = this.parseServerResponse(response.body);
        if (responseBody === null) {
          return;
        }
        const responseData = responseBody.data;
        console.log('responseData:', responseData);
        this.updatePlayersScoreFromGameDTO(responseData);

        // TODO replace with the one from core
        const themeDTO = {
          blue: 153,
          displayMultilanguageText: 'The World',
          green: 112,
          iconUrl: 'static/images/cat_icons/the world.svg',
          id: 1,
          name: null,
          red: 35,
          relatedImgUrl: null,
          score: 0,
          totalAnswers: 0,
          totalCorrectAnswers: 0,
          type: 'THE_WORLD',
          used: false,
        };
        this.setPlayersCurrentSelectedTheme({
          homePlayerCurrentSelectedTheme: themeDTO,
          awayPlayerCurrentSelectedTheme: themeDTO,
        });

        if (responseData.gameStateEnum === 'SHOW_ROUND_ENDED' || responseData.gameStateEnum === 'SHOW_GAME_ROUND_END') {
          this.goToRoundEndedScreen = true;
        }

        if (responseData.gameStateEnum === 'CTA_TO_BE_ANSWERED') {
          this.subscription3.unsubscribe();
          this.saveQuestionData(responseData);
          this.saveQuestionDataForNextQuestion(responseData);
          this.normalTransition = true;
          console.log('going to game page...');
          this.updateResumingStatusAndGoToPage('/game');
        }
      });
    },
    getThemesForNextRound() {
      console.info(`Subscribing to channel: /topic/categoriesFetched/${this.gameID}`);
      this.subscription4 = this.stompClient.subscribe(`/topic/categoriesFetched/${this.gameID}`, (response) => {
        console.log('[ResumingGame] Inside categoriesFetched response');
        // parse server response and return if any errors occur
        const responseData = this.parseServerResponse(response.body);
        if (responseData === null) {
          return;
        }
        console.log('responseData', responseData);
        console.log('Always in Hidden Img Themes are null, so if GAME_FINISHED fetched go to Round Ended Page');
        if (responseData.gameStateEnum === 'CATEGORIES_FETCHED' || responseData.gameStateEnum === 'GAME_FINISHED') {
          this.goToRoundEndedScreen = true;
          console.log('this.goToRoundEndedScreen:', this.goToRoundEndedScreen);
          if (this.goToRoundEndedScreen) {
            console.log('Game Finished ENUM Fetched....');
            this.subscription4.unsubscribe();
            this.setCurrentRoundNumber(responseData.homeUserDetails.roundDTOList.length);
            this.saveQuestionNumber(responseData);
            this.saveRoundData(responseData);
            this.normalTransition = true;
            console.log('going to roundEnded page...');
            this.updateResumingStatusAndGoToPage('/roundEnded');
          } else {
            this.subscription4.unsubscribe();
            this.setCurrentRoundNumber(responseData.homeUserDetails.roundDTOList.length + 1);
            this.updatePlayersScoreFromGameDTO(responseData);
            this.setPlayersCurrentThemes({
              homePlayerCurrentThemes: responseData.homeUserDetails.themeDTOList,
              awayPlayerCurrentThemes: responseData.awayUserDetails.themeDTOList,
            });
            this.normalTransition = true;
            console.log('going to selectTheme page...');
            this.updateResumingStatusAndGoToPage('/selectTheme');
          }
        }
      });
    },
  },
  computed: {
    ...mapState('game', [
      'gameStateEnumForResumeGame',
      'gameIsResuming',
      'gameID',
      'playersDetails',
      'currentRoundNumber',
      'currentQuestionNumber',
    ]),
    ...mapState('common', [
      'timeWinnerIndication',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/ResumingGame.vue